import { HttpClient, HttpEvent } from '@angular/common/http';
import { error } from '@angular/compiler/src/util';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GroupWord } from '../interfaces/GroupWord.interface';

@Injectable({
  providedIn: 'root',
})
export class GroupWordService {
  url = '@cec-api/group-words/';

  constructor(private http: HttpClient) {}

  get(): Promise<any> {
    return this.http.get(this.url).toPromise();
  }

  getById(id: number): Promise<any> {
    return this.http.get(this.url + id).toPromise();
  }

  add(groupWord: GroupWord): Promise<any> {
    return this.http.post(this.url, groupWord).toPromise();
  }

  add1(form: FormData): Observable<HttpEvent<Object>> {
    return this.http.post('@cec-api/group-words', form, {
      reportProgress: true,
      observe: 'events',
      headers: { encrypt: 'multipart/form-data' },
    });
  }

  file(id): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.http
        .get('@cec-api/group-words/' + id + '/document', {
          responseType: 'blob',
        })
        .subscribe(
          (res) => resolve(res),
          (error) => {
            reject(error);
          }
        );
    });
  }
  /*  update(user: Patrimony, id: number): Promise<any>{
    return this.http.put(this.url+id, user).toPromise();
  }

  delete(id:number){
    return this.http.delete(this.url+id).toPromise();
  }

  search(searchValue: string):Promise<any>{
    return this.http.get(this.url+'search?name='+ searchValue).toPromise();
  } */
}
